import { PricingProduct } from '../../../store/features/products/types';
import { useRootSelector } from '../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../store/features/products';

export function useProductPricing(product: PricingProduct) {
  const { priceInclVat: isPriceInclVat, tier } = useRootSelector(
    selectSitePricingProductsData,
  );

  return {
    finalPrice: isPriceInclVat
      ? product.priceInclVatWithVip
      : product.discountsAppliedPrice,
    initialPrice: product.startPrice,
    tieredSavingEndDate: tier.endDate,
    vatValue: product.vatWithVip,
    discounts: {
      vipCodeSavings: product.vipCodeSavings,
      tieredSaving: product.tieredSaving,
    },
  };
}
